import { t } from 'ttag'

import * as earlyGameboard from './earlyGameboard'

import * as h2Api from '../h2Api'

export const CLUSTER_PROFILE_LOAD = 'CLUSTER_PROFILE_LOAD'
export const CLUSTER_SORT_OCCUPATIONS = 'CLUSTER_SORT_OCCUPATIONS'
export const CLUSTER_SELECT_LOADED = 'CLUSTER_SELECT_LOADED'
export const PROFILE_LOG = 'CLUSTER_PROFILE_LOG'
export const TOGGLE_MODAL = 'CLUSTER_TOGGLE_MODAL'
export const TOGGLE_POPULARITY_MODAL = 'CLUSTER_TOGGLE_POPULARITY_MODAL'
export const CLUSTER_LISTING_LOADED = 'CLUSTER_LISTING_LOADED'
export const RATE_CLUSTER = 'RATE_CLUSTER'
export const LOCAL_LOADED = 'CLUSTER_LOCAL_LOADED'
export const LOCAL_LOADING = 'LOCAL_LOADING'
export const PATHWAY_FILTER_SELECTED = 'PATHWAY_FILTER_SELECTED'
export const PROFILE_LOG_PERSONALIZATION = 'PROFILE_LOG_PERSONALIZATION'

export const getOccupationSort = (key, state, clusterFilterToPathway) => {
  const myMap = {}
  const numToReturn = 25

  state.occupations.details.forEach(o => (myMap[o.socCode] = o))

  const filterToPathway = lst => {
    const pathwayId = clusterFilterToPathway

    if (pathwayId) {
      const pw = state.pathways.find(p => p.id === pathwayId)

      return (
        pw &&
        lst.filter(o => pw?.onetSocs.indexOf(myMap[o.socCode].onetSoc) >= 0 ?? false)
      )
    }

    return lst
  }

  switch (key) {
    case 3:
      return {
        extraDataTitle: t`Estimated Employment`,
        jobZones: state.occupations.jobZones,
        data: filterToPathway(state.occupations.outlook)
          ?.sort((a, b) => b.estimatedEmployment - a.estimatedEmployment)
          ?.slice(0, numToReturn)
          ?.map(o => {
            const mm = myMap[o.socCode]

            return {
              ...mm,
              extraData: o.estimatedEmployment
                ? o.estimatedEmployment.toLocaleString()
                : ''
            }
          })
      }
      break
    case 2:
      return {
        extraDataTitle: t`Annual Openings`,
        jobZones: state.occupations.jobZones,
        data: filterToPathway(state.occupations.outlook)
          ?.sort((a, b) => b.annualAverage - a.annualAverage)
          ?.slice(0, numToReturn)
          ?.map(o => {
            const mm = myMap[o.socCode]

            return {
              ...mm,
              extraData: o.annualAverage
                ? `${o.annualAverage.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}%`
                : ''
            }
          })
      }
      break
    default:
      return {
        extraDataTitle: t`Annual Wage`,
        jobZones: state.occupations.jobZones,
        data: filterToPathway(
          state.occupations.highestPaying?.filter(o => o.annualAverage)
        )
          ?.slice(0, numToReturn)
          ?.map(o => {
            const mm = myMap[o.socCode]

            return {
              ...mm,
              extraData: o.annualAverage
                ? o.annualAverage
                    .toLocaleString('en-US', { style: 'currency', currency: 'USD' })
                    ?.slice(0, -3)
                : ''
            }
          })
      }
      break
  }
}

export const toggleClusterActivityModal = s => dispatch => {
  dispatch({ type: TOGGLE_MODAL, state: s })
}

export const togglePopularityModal = s => dispatch => {
  dispatch({ type: TOGGLE_POPULARITY_MODAL, state: s })
}

export const selectLocalTab = (clusterId, tab) => dispatch => {
  dispatch({ type: LOCAL_LOADING })

  return dispatch(
    h2Api.get(`/pathways/clusters/${clusterId}/opportunities/${tab}`)({
      type: LOCAL_LOADED,
      selectedLocalTab: tab
    })
  )
}

export const selectPathwayFilter = p => dispatch => {
  console.log(p)

  return Promise.resolve(
    dispatch({
      type: PATHWAY_FILTER_SELECTED,
      pathway: p === '-1' ? null : p
    })
  )
}

export const sortOccupationsBy = key => (dispatch, getState) => {
  //console.log(getState())
  const clust = getState().clusterProfile

  return Promise.resolve(
    dispatch({
      type: CLUSTER_SORT_OCCUPATIONS,
      key,
      listing: getOccupationSort(
        key,
        clust.clusterCache[clust.selectedCluster],
        clust.clusterFilterToPathway
      )
    })
  )
}

export const loadClusters = asMajors => dispatch => {
  const qString = asMajors ? '?type=major' : ''

  return dispatch(
    h2Api.get(`/pathways/clusters${qString}`)({ type: CLUSTER_LISTING_LOADED })
  )
}

export const toggleClusterFlag = cluster => dispatch => {
  return dispatch(
    h2Api.put(
      `/user/flag/cluster/${cluster.id}`,
      {}
    )({
      type: RATE_CLUSTER,
      clusterId: cluster.id
    })
  )
}

export const rateCluster = (cluster, ratingType) => dispatch => {
  //console.log("RATING", occupation, ratingType)
  return dispatch(
    h2Api.put(`/user/rate/cluster/${cluster.id}`, {
      rating: ratingType
    })({ type: RATE_CLUSTER, clusterId: cluster.id })
  )
}

export const loadCluster = (clusterId, withPersonalization) => (dispatch, getState) => {
  const exists = () => {
    const cluster = getState().clusterProfile.clusterCache[clusterId]

    if (cluster || !withPersonalization) {
      dispatch({ type: CLUSTER_SELECT_LOADED, selectedCluster: clusterId })

      if (withPersonalization) {
        return dispatch(
          h2Api.post(`/pathways/clusters/${clusterId}/log-personalizations`)({
            type: PROFILE_LOG_PERSONALIZATION
          })
        )
      }

      return dispatch(
        h2Api.post(`/pathways/clusters/${clusterId}/log`)({ type: PROFILE_LOG })
      )
    }

    return dispatch(
      h2Api.get(`/pathways/clusters/${clusterId}`)({ type: CLUSTER_PROFILE_LOAD })
    )
  }

  return exists().then(() => {
    dispatch({
      type: earlyGameboard.REGISTER_VIEW,
      activityKey: 'clusters',
      activityValue: {
        clusterId,
        earlyExploration: true
      }
    })
  })
}
